/**
 * Липка кнопка "Додати в кошик" на мобільних.
 *
 * Не дублює форму: кнопка всередині має form="product-form-{section}",
 * тож сабмітить ту саму форму, що й основна кнопка, і <product-form>
 * перехоплює submit так само (варіант і кількість завжди актуальні).
 *
 * Показується лише після того, як основна кнопка прокрутилась ВГОРУ
 * за межі екрана.
 */
class StickyAtc extends HTMLElement {
  connectedCallback() {
    this.sectionId = this.dataset.sectionId;
    this.button = this.querySelector('[data-sticky-submit]');
    this.priceTarget = this.querySelector('[data-sticky-price]');

    this.sourceButton = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
    this.sourcePrice = document.getElementById(`price-${this.sectionId}`);
    this.productInfo = document.getElementById(`ProductInfo-${this.sectionId}`);

    if (!this.sourceButton) return;

    this.sync();
    this.observeVisibility();
    this.observeChanges();
  }

  disconnectedCallback() {
    this.intersectionObserver?.disconnect();
    this.mutationObserver?.disconnect();
  }

  /** Показати, коли основна кнопка пішла вгору за межі екрана. */
  observeVisibility() {
    this.intersectionObserver = new IntersectionObserver(
      ([entry]) => {
        const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        this.classList.toggle('is-visible', scrolledPast);
      },
      { threshold: 0 }
    );
    this.intersectionObserver.observe(this.sourceButton);
  }

  /**
   * Dawn перерендерює блок при зміні варіанта — основна кнопка
   * замінюється новою нодою, тож переперевіряємо після кожної зміни.
   */
  observeChanges() {
    if (!this.productInfo) return;
    this.mutationObserver = new MutationObserver(() => this.onProductInfoChange());
    this.mutationObserver.observe(this.productInfo, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['disabled'],
    });
  }

  onProductInfoChange() {
    const current = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
    if (current && current !== this.sourceButton) {
      this.intersectionObserver?.disconnect();
      this.sourceButton = current;
      this.observeVisibility();
    }
    this.sourcePrice = document.getElementById(`price-${this.sectionId}`) || this.sourcePrice;
    this.sync();
  }

  /** Дзеркалимо стан і підпис основної кнопки + ціну. */
  sync() {
    if (!this.button || !this.sourceButton) return;

    this.button.disabled = this.sourceButton.disabled;

    const label = this.sourceButton.querySelector('span:not(.visually-hidden)');
    const target = this.button.querySelector('span');
    if (label && target) target.textContent = label.textContent.trim();

    if (this.priceTarget && this.sourcePrice) {
      const price =
        this.sourcePrice.querySelector('.price-item--sale') ||
        this.sourcePrice.querySelector('.price-item--regular');
      if (price) this.priceTarget.textContent = price.textContent.trim();
    }
  }
}

if (!customElements.get('sticky-atc')) {
  customElements.define('sticky-atc', StickyAtc);
}
